<template>
  <div class="table-responsive static-datatable">
    <table ref="staticDataTable" :class="['table', variant, striped ? 'table-striped' : '', hover ? 'table-hover' : '', smallRows ? 'table-sm' : '']" style="width:100%;">
      <thead>
        <slot name="header" />
      </thead>
      <tbody ref="staticDataTableBody">
        <slot name="body" />
      </tbody>
    </table>
    <p class="font-italic text-center text-muted"><slot name="empty" /></p>
  </div>
</template>

<style>
.static-datatable-row-draggable {
  cursor: move;
}
.static-datatable {
  overflow: visible;    /* JB: Popovers & draggable items cause issues if this isn't set this way */
}
.table tbody tr.static-datatable-row-nostripe {
  background-color: transparent;
}
.table tbody tr.static-datatable-row-nostripe:hover td {
  background-color: transparent;
}
.static-datatable .static-datatable-striped {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>

<script>
export default {
  name: "StaticDataTable",
  props: {
    variant: String,
    editing: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Object,
      default: function() {
        return { columns: [], rows: [] };
      }
    },
    striped: {
      type: Boolean,
      default: true
    },
    hover: {
      type: Boolean,
      default: true
    },
    smallRows: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sortableSetup: false
    }
  },
  mounted() {
    if(this.editing) {
      this.setupDraggable()
    }    
  },
  beforeDestroy() {
    if(this.$data.sortableSetup)
      $(this.$refs.staticDataTableBody).sortable('destroy')
    this.$data.sortableSetup = false
  },
  watch: {
    "tableData.rows": function(newVal, oldVal) {
      //if(newVal.count > 0) {
      this.tableData.columns.forEach((element, index) => {
        if (element.render != undefined) {
          newVal.forEach((rowData, rowIndex) => {
            newVal[rowIndex][element.data] = element.render(
              newVal[rowIndex][element.data],
              newVal[rowIndex]
            );
          });
        }
      });
      //}
    },
    editing: function(newVal, oldVal) {
      if(newVal) {
        this.setupDraggable()
      } else {
        if(this.$data.sortableSetup) {
          $(this.$refs.staticDataTableBody).sortable('destroy')
        }
        this.$data.sortableSetup = false
      }
    },
  },
  methods: {
    setupDraggable() {
      if(this.$data.sortableSetup)
        return

      this.$data.sortableSetup = true
      $(this.$refs.staticDataTableBody).sortable({ 
        handle: '.static-datatable-row-draggable',
        axis: 'y',
        items: '> tr.static-table-sortable',
        start: (event, ui) => {
          this.$emit('sortStarted')
        },
        stop: (event, ui) => {
          this.$emit('sortStopped')

          var sortOrder = []
          $(this.$refs.staticDataTableBody).children('tr').each(function(index, child) {
            sortOrder.push($(this).data('sort-id'))
          })

          // Send out event with new order array
          this.$emit('sortUpdated', sortOrder)
        }
      });
    }
  }
};
</script>
